module.exports = __webpack_public_path__ + "img/quick_access.7d5803c8.svg";